import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuAction } from '@/models/MenuAction.model';
import uuid from 'uuid/v4';
import $ from 'jquery';
import OverlayScrollbars from 'overlayscrollbars';
import { GridColumn } from '@/models/GridColumn.model';
import { Grid } from '@/models/Grid.model';
import { SortDir } from '@/models/SortDir';
import { RowAction } from '@/models/RowAction.model';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class DataTableWidgetComponent extends Vue {

  @Prop()
  private requestorCallback!: any;

  @Prop(Array)
  private columns!: GridColumn[];

  @Prop(Array)
  private dataTableMenuActions!: MenuAction[];

  @Prop(Array)
  private rowMenuActions!: MenuAction[];

  @Prop(Array)
  private rowActions!: RowAction[];

  @Prop({ type: Object as () => Grid })
  private tableData!: Grid;

  @Prop(Boolean)
  private loadingProp!: boolean;

  @Prop(Boolean)
  private noPagination!: boolean;

  @Prop(Boolean)
  private applyPerfectScrollbar!: boolean;

  @Prop(Boolean)
  private searching!: boolean;

  @Prop(Boolean)
  private filterGrid!: boolean;

  @Prop(Boolean)
  private showFilterGridAlways!: boolean;

  @Prop(Boolean)
  private showResultCount!: boolean;

  @Prop(Boolean)
  private allCheckboxColumn!: boolean;

  @Prop(Boolean)
  private addRowBtn!: boolean;

  @Prop(Boolean)
  private showResultTitle3!: boolean;

  @Prop(Boolean)
  private hideTopRowMenuActions!: boolean;

  @Prop(String)
  private hideRowCheckboxProperty!: string;

  @Prop(String)
  private title!: string;

  @Prop(String)
  private addRowBtnText!: string;

  @Prop(String)
  private dataTableMenuText!: string;

  @Prop(Number)
  private pageNumber!: number;

  @Prop(Boolean)
  private noResultsAdditionalInfo!: boolean;

  @Prop({ type: Number, default: 10 })
  private pageSize!: number;

  private searchFilter: string = '';
  private grid: Grid = {} as Grid;
  private previousResults: [] = [];
  private loading: boolean = false;
  private noResults: boolean = false;
  private gridId: string = '';
  private sortColumn: string = '';
  private activeRow: number = -1;
  private selectedRows: any = {};
  private filterClicked: boolean = false;
  private stopRowClick: boolean = false;
  private currentPage: number = 1;

  private mounted() {
    this.gridId = 'grid' + uuid();
    this.grid = this.tableData;
    this.selectedRows = {
      1: [],
    };
    if (this.applyPerfectScrollbar) {
      this.calcPerfectTableHeight();
      OverlayScrollbars(document.querySelectorAll('#os1'), { normalizeRTL: false });
    }
    this.filterClicked = false;
    this.$root.$on('clear-selected-rows', this.clearSelectedRows);
  }

  private onFilterClicked() {
    this.filterClicked = true;
    this.$emit('filterClicked', true);
  }

  private onCloseFilterClicked() {
    this.searchFilter = '';
    this.filteringGrid();
    this.filterClicked = false;
    this.$emit('filterClicked', false);
  }

  private onRowClicked(item: any, idx: any) {
    this.activeRow = idx;
    if (!this.stopRowClick) {
      this.$emit('onRowClicked', item);
    }
    this.stopRowClick = false;
  }

  private clearSelectedRows() {
    this.selectedRows = {
      1: [],
    };
  }

  private onTdClicked(item: any, row: any) {
    this.$emit('onTdClicked', item, row);
  }

  private onAddClicked() {
    this.$emit('onAddClicked');
  }

  private onRowActionClicked(action) {
    this.$emit('onRowActionClicked', action, this.selectedRows);
  }

  private onStopRowClick() {
    this.stopRowClick = true;
  }

  private onPageChange(page: number) {
    this.currentPage = page;
    this.selectedRows[page] = this.selectedRows[page] || [];
    this.selectedRows = { ...this.selectedRows };
    this.$emit('onPageChange', page);
  }

  private onRecordsPerPageChanged(records: number) {
    this.$emit('onRecordsPerPageChanged', records);
  }

  private onTableHeaderClicked(tableHeader: GridColumn) {
    if (!tableHeader.hideSorting) {
      tableHeader.sortDirection = !tableHeader.sortDirection || tableHeader.sortDirection === SortDir.DESC ?
        SortDir.ASC : SortDir.DESC;
      tableHeader.sortColumn = tableHeader.property;
      this.sortColumn = tableHeader.sortColumn;
      this.$emit('onTableHeaderClicked', tableHeader);
    }
  }

  private getResultCount(count) {
    return !count ? 0 : (count <= 5000 ? count : 5000);
  }

  get showResultCountTooltip(): boolean {
    if (!this.tableData?.resultCount) {
      return false;
    }

    return this.tableData?.resultCount > 5000;
  }

  get selectAll(): boolean {
    if (!this.selectedRows[this.currentPage]) {
      return false;
    }
    if (this.hideRowCheckboxProperty) {
      const filteredTableData = this.tableData.results.filter(t => t[this.hideRowCheckboxProperty]);
      return filteredTableData.length === this.selectedRows[this.currentPage].length;
    } else {
      return this.tableData.results.length === this.selectedRows[this.currentPage].length;
    }
  }

  set selectAll(value: boolean) {
    const selected: any[] = [];
    if (value) {
      this.tableData.results.forEach((result) => {
        if (!this.hideRowCheckboxProperty || result[this.hideRowCheckboxProperty]) {
          selected.push(result);
        }
      });
    }
    this.selectedRows[this.currentPage] = selected;
  }

  private filteringGrid() {
    const $rows = $('#' + this.gridId + ' table tbody tr');
    const reg = RegExp(this.searchFilter || '');
    let text;
    this.noResults = $rows.show().filter((index: any, el: any) => {
      text = $(el).text().replace(/\s+/g, ' ');
      return !reg.test(text);
    }).hide().length === this.tableData!.resultCount;
  }

  private calcPerfectTableHeight() {
    const firstTableCont: any = document.getElementById('os');
    const firstTable: any = document.getElementById('os')!.getElementsByTagName('table')[0];
    const secondTableCont: any = document.getElementById('os1');
    const secondTable: any = document.getElementById('os1')!.getElementsByTagName('table')[0];
    const firstTableHeight = firstTable.getElementsByTagName('thead')[0].clientHeight + 'px';
    firstTableCont.style.height = firstTableHeight;
    secondTable.style.marginTop = '-' + firstTableHeight;
    const topPos = secondTableCont.getBoundingClientRect().top + window.scrollY;
    const footerHeight = document.getElementsByTagName('footer')[0].clientHeight;
    secondTableCont.style.maxHeight =
      'calc(100vh - 2.25rem - ' + firstTableHeight + ' - ' + topPos + 'px' + ' - ' + footerHeight + 'px)';
  }

}
